import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.conversation.WmConversationEntryDropzone.';
  public static readonly attachments = `${Id.prefix}attachments`;
  public static readonly couldNotUploadFile = `${Id.prefix}couldNotUploadFile`;
  public static readonly maxUploadCount = `${Id.prefix}maxUploadCount`;
  public static readonly chooseFiles = `${Id.prefix}chooseFiles`; // New key
  public static readonly chooseFile = `${Id.prefix}chooseFile`;
  public static readonly duplicateFile = `${Id.prefix}duplicateFile`; // New key
  public static readonly pasteFile = `${Id.prefix}pasteFile`;
  public static readonly pasteHint = `${Id.prefix}pasteHint`;
  public static readonly clipboardHasNoFile = `${Id.prefix}clipboardHasNoFile`;
  public static readonly pasteNotAFile = `${Id.prefix}pasteNotAFile`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangDealerFranchiseeConversationWmConversationEntryDropzone {
  private constructor() {}

  public static attachments(): string {
    return interpolate(Id.attachments);
  }

  public static couldNotUploadFile(): string {
    return interpolate(Id.couldNotUploadFile);
  }

  public static maxUploadCount(params: { maxFiles: number }): string {
    return interpolate(Id.maxUploadCount, params);
  }

  public static chooseFiles(): string {
    // New method
    return interpolate(Id.chooseFiles);
  }

  public static chooseFile(): string {
    return interpolate(Id.chooseFile);
  }

  public static pasteFile(): string {
    return interpolate(Id.pasteFile);
  }

  public static pasteHint(): string {
    return interpolate(Id.pasteHint);
  }

  public static clipboardHasNoFile(): string {
    return interpolate(Id.clipboardHasNoFile);
  }

  public static pasteNotAFile(): string {
    return interpolate(Id.pasteNotAFile);
  }

  public static duplicateFile(): string {
    // New method
    return interpolate(Id.duplicateFile);
  }
}

export class DealerFranchiseeConversationWmConversationEntryDropzoneModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.attachments, 'Attachments', 'Caption for attachments section');
    register.add(Id.couldNotUploadFile, 'Could not upload file', 'Error message for failed upload');
    register.add(
      Id.maxUploadCount,
      'Max upload count {{maxFiles}} has been reached. Please remove a file before adding a new file.',
      'Error message when max upload count is reached'
    );
    register.add(Id.chooseFiles, 'Choose files', 'Button: choose files when more than one is allowed'); // New registration
    register.add(Id.chooseFile, 'Choose file', 'Button: choose a file when only one is allowed');
    register.add(Id.duplicateFile, 'This file has already been added.', 'Error: duplicate file'); // New registration
    register.add(Id.pasteFile, 'Paste', 'Button: paste a file from the clipboard');
    register.add(Id.pasteHint, 'Press Ctrl+V to paste a file', 'Hint shown on the focused drop zone');
    register.add(
      Id.clipboardHasNoFile,
      'No file could be read from the clipboard. If you copied a file rather than its contents, ' +
        'hover over or click the drop zone and press Ctrl+V. This is a browser security restriction: a page ' +
        'is never allowed to read a copied file off the clipboard, so only Ctrl+V can hand it over.',
      'Message when the clipboard holds no file the button can read'
    );
    register.add(
      Id.pasteNotAFile,
      'Nothing on the clipboard could be used as a file here. Copy a file first, or use Choose file.',
      'Message when a paste aimed at the drop zone held no usable file'
    );
  }
}
